import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { SharedState } from '~shared-components/redux/sharedState'

import { TranslationMap } from '../translations/default'
import { makeTranslateFn, TFn } from '../translations/translations'

export function useTranslations(): TFn {
  const translations = useSelector<SharedState, TranslationMap>(
    state => state.translations.strings,
  )

  return useMemo(() => makeTranslateFn(translations), [translations])
}
